import script from "./FeedbackPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackPage.vue?vue&type=style&index=0&id=23040518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23040518"]])

export default __exports__